import { useEffect, useState } from 'react'

import { setStorageSerializedItem } from '../../../../../utils/storage'
import {
  getBirdviewStorageItemSetKey,
  getBirdviewStorageKey,
  readBirdviewStorageItem,
  reconcileBirdviewOrder,
} from '../../../DashboardBirdview.utils.storage'

import { moveBirdviewTileRowOrder } from './useBirdviewTileRowOrder.utils'

// A layout with other tiles gets its own key instead of inheriting a partial
// order.
export function useBirdviewTileRowOrder({ defaultOrder, storageKeyPrefix }) {
  const storageKey = getBirdviewStorageKey(storageKeyPrefix, [
    getBirdviewStorageItemSetKey(defaultOrder),
  ])

  const [order, setOrder] = useState(() =>
    reconcileBirdviewOrder(
      readBirdviewStorageItem(storageKey, Array.isArray),
      defaultOrder
    )
  )

  useEffect(() => {
    setStorageSerializedItem(storageKey, order)
  }, [order, storageKey])

  function handleDragEnd({ active, over }) {
    if (over && active.id !== over.id) {
      setOrder(prev => moveBirdviewTileRowOrder(prev, active.id, over.id))
    }
  }

  return { handleDragEnd, order }
}
